import React, {useState} from "react";
import * as UserService from "../../api/UserService";
import {useNavigate} from "react-router-dom";
import cabinetStyle from "./MentorCabinet.module.css";
import DialogComponent from "../DialogComponent";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import {useTranslation} from "react-i18next";

export default function Logout() {
    const [exitDialog, setExitDialog] = useState(false)
    const nav = useNavigate()
    const { t } = useTranslation('translation', { keyPrefix: 'logout' });

    function logout() {
        UserService.logout(() => nav("/"))
    }

    return (
        <div className={`${cabinetStyle.newLogout} ${cabinetStyle.sideBarText}`}>
            <div onClick={() => {
                setExitDialog(true)
            }} >
                <ExitToAppIcon/>
                <span style={{ paddingLeft: "20px" }}>{t('logOut')}</span>
            </div>
            {exitDialog && <DialogComponent onClose={() => {
                setExitDialog(false)
            }} onConfirm={logout} title={t('wantToLoOut')}/>}
        </div>

    );
}